import { makeAutoObservable } from 'mobx'
import { IBreadcrumb } from '../services/RouterService'

export class UIStore {
  public loading = false
  breadcrumbs: IBreadcrumb[] = []

  constructor() { makeAutoObservable(this) }
}
